import React from 'react';
import UDIDropdownfield from "./UDIDropdownfield.js"

const UDIDIDeviceStatus = ({
	UDI,
	setUDI,
	forceIsEditing = null
}) => {

	const fieldName = "UDI_DI_DeviceStatus";
	const fieldTitle = "UDI-DI / Device Status";
	const LOV = [

		{ key: "", value: "" },
		{ key: "ON_THE_MARKET", value: "On the EU market" },
		{ key: "NO_LONGER_PLACED_ON_THE_MARKET", value: "No longer placed on the EU market" },
		{ key: "NOT_INTENDED_FOR_EU_MARKET", value: "Not intended for the EU market" }

	];

	return <>
		<UDIDropdownfield UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} LOV={LOV} mandatory={true} forceIsEditing={forceIsEditing} />
	</>											  
}


export default UDIDIDeviceStatus;


